import { useQuery } from '@gogame/query';

import { loadErrorDetails } from 'scenes/TapjoyBidUpdate/sources/tapjoy-bid-update';

import { errorDetails } from './queryKeyFactory';

export const useLoadErrorDetails = () => {
  return useQuery(errorDetails, loadErrorDetails);
};
